/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Page_OfInputs */



/**
* | output |
* | --- |
* | "of" |
*
* @param {Ccsl_Export_Page_OfInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_page_of = /** @type {((inputs?: Ccsl_Export_Page_OfInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Page_OfInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (" sur ")
	if (locale === "de") return /** @type {LocalizedString} */ (" von ")
	if (locale === "it") return /** @type {LocalizedString} */ (" Di ")
	if (locale === "ru") return /** @type {LocalizedString} */ (" из ")
	if (locale === "es") return /** @type {LocalizedString} */ (" de ")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (" 的 ")
	if (locale === "ja") return /** @type {LocalizedString} */ (" の ")
	if (locale === "hi") return /** @type {LocalizedString} */ (" का ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (" de ")
	return /** @type {LocalizedString} */ (" of ")
});